import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import useAiAgents from '../components/aiAgentCenter/useAiAgents';
import { useAiAssistant } from '../components/pages/ai-assistant/useAiAssistant';
import { selectCrmOrgHasManagePackage } from '../components/pages/environments/environmentsReducer';
import { useFeatureToggle } from '../feature-flags/useFeatureToggle';
import { useFetchTags } from '../components/documentation/salesforce-documentation-card/annotations/tags/useFetchTags';
import { useDefaultEnvId } from '../components/pages/environments/DefaultEnvContext';

/**
 * Add an effect to any call that should be triggered whenever crmOrgId changes
 */

export const useFetchUponCrmOrgChange = () => {
  const crmOrgId = useDefaultEnvId();
  const isManagePackageInstalled = useSelector(selectCrmOrgHasManagePackage(crmOrgId ?? ''));
  const { supportAgentInAgenticCenter } = useFeatureToggle();
  const { fetchAiAgents } = useAiAgents();
  const { fetchAiAssistantConversations: fetchAiAssistentConversations, fetchApps } =
    useAiAssistant();
  const fetchTags = useFetchTags();

  useEffect(() => {
    if (crmOrgId) {
      fetchAiAgents();
    }
  }, [crmOrgId, fetchAiAgents]);

  useEffect(() => {
    // since we load ai agents data on crm org change, we also need toload ai assistant data
    // if manage package is installed and feature flag is enabled
    if (isManagePackageInstalled && supportAgentInAgenticCenter && crmOrgId) {
      fetchApps(crmOrgId);
      fetchAiAssistentConversations(crmOrgId);
    }
  }, [
    crmOrgId,
    fetchAiAssistentConversations,
    fetchApps,
    supportAgentInAgenticCenter,
    isManagePackageInstalled,
  ]);

  useEffect(() => {
    if (crmOrgId) {
      fetchTags();
    }
  }, [crmOrgId, fetchTags]);
};
